import { GetObjectCommand, ListObjectsV2Command } from '@aws-sdk/client-s3';
import { getS3Client } from 'src/services/aws/S3Service';
import { S3_ENV_CONSTANTS } from 'src/constants/EnvironmentConstants';

const PREFIX = 'upstream/ACCOUNTING_DAYS_STARMAP/';

export interface WorkDayCalendarEntry {
  work_day_number: number;
  neg_work_day_number: number;
  calendar_date: string;
}

export const fetchWorkDayCalendar = async (): Promise<WorkDayCalendarEntry[]> => {
  const s3Client = getS3Client();
  if (!s3Client) throw new Error('S3 client not available');

  const bucket = S3_ENV_CONSTANTS.ENVIRONMENT_VARIABLES.Bucket;

  // List all JSON objects under the prefix (handles pagination)
  let keys: string[] = [];
  let continuationToken: string | undefined;
  do {
    const listResp = await s3Client.send(new ListObjectsV2Command({ Bucket: bucket, Prefix: PREFIX, ContinuationToken: continuationToken }));
    const pageKeys = (listResp.Contents ?? []).map((obj) => obj.Key).filter((k): k is string => !!k && k.endsWith('.json'));
    keys = keys.concat(pageKeys);
    continuationToken = listResp.IsTruncated ? listResp.NextContinuationToken : undefined;
  } while (continuationToken);

  // Fetch and parse each JSON part file
  const results: WorkDayCalendarEntry[] = [];
  for (const key of keys) {
    const resp = await s3Client.send(new GetObjectCommand({ Bucket: bucket, Key: key }));
    const text = await resp.Body!.transformToString();
    const lines = text.trim().split('\n');
    for (const line of lines) {
      results.push(JSON.parse(line));
    }
  }

  return results;
};
